module.exports = __webpack_public_path__ + "static/media/end-title.70d579eb.svg";